module.exports = __webpack_public_path__ + "images/glam-footer__2L0Bx.png";